import React from "react";

const WireLine = props => {
  let {
    startx,
    starty,
    endx,
    endy,
    lineColor,
    circleColor,
    onMouseEnter,
    onMouseLeave,
    sensorid,
    widgetid,
    onRemoveConnection
  } = props;

  return (
    <g>
      <line
        x1={startx}
        y1={starty}
        x2={endx}
        y2={endy}
        stroke={lineColor}
        strokeWidth="3"
        className="anim-path"
      />
      <circle
        cx={endx}
        cy={endy}
        r="8"
        fill={circleColor}
        onClick={() => {
          onRemoveConnection(widgetid, sensorid);

        }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </g>
  );
};

export default WireLine;
